import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ScheduleTimeView} from "./scheduleTimeView";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import TimeSpan from "../../../shared/TimeSpan";
import {Router} from "@/rawdogjs/src/router";
import {UserStore} from "../../../data/stores/UserStore";
import {BookingStore} from "../../../data/stores/BookingStore";
import {BookingApi} from "../../../services/api/base/BookingApi";
import {LoadingPresenter} from "../../loading/loadingPresenter";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {UuidHelper} from "../../../shared/IdentityHelper";

export class ScheduleTimePresenter implements IPresenter {

    public _view: ScheduleTimeView;
    private dependencyContainer: ParcelDependencyContainer;

    private selectedDate: Date | null;
    private selectedTime: TimeSpan | null;
    private times: any[];

    private _router: Router;
    private _userStore: UserStore;
    private _bookingStore: BookingStore;
    private _queryParams: Record<string, string>;
    private _bookingApi: BookingApi;
    private _loading: LoadingPresenter;

    constructor(scheduleTimeView: ScheduleTimeView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = scheduleTimeView;
        this._router = router;
        this.dependencyContainer = dependencyContainer;
    }

    async initialize() {


        const renderComponent = new RenderComponent(this._router);
        this._loading = await renderComponent.render<LoadingPresenter>('loading');
        this._view.$element.append(this._loading._view.$element);

        this._userStore = this.dependencyContainer.resolve<UserStore>('UserStore');
        this._bookingStore = this.dependencyContainer.resolve<BookingStore>('BookingStore');
        this._bookingApi = this.dependencyContainer.resolve<BookingApi>('BookingApi');

        this._loading.setBody("Loading data...")
        this._loading.show(true);
        
        await this._bookingStore.pull();
        
        this._loading.show(false);

        let booking = await this._bookingStore.getBooking();

        this.setSelectedDate(new Date(booking.bookingDate));
        
        if(booking?.bookingTime){
            await this.setSelectedTime(TimeSpan.fromString(booking.bookingTime));
        }

        this._view.scrollToTop();
    }

    private setSelectedDate(selectedDate: Date) {
        this.selectedDate = selectedDate;
        this._view.setTextById('selected-date-label',
            this.formatDate(this.selectedDate)
        );
        this.loadTimes(this.selectedDate);
    }
    
    private async saveTimeSelection(){

        this._loading.setBody('Saving your selection...');
        this._loading.show(true);
        
        const booking = this._bookingStore.getBooking();
        
        try {
            
            const result = await this._bookingApi.post({
                    setBookingTime: {
                        id: booking.id, // if we don't already have an id, create one
                        time: this.selectedTime.toString()
                    }
                },
                this._userStore.getParentTenant(),
                true,
                false
            );

            if(result.status === 200) {
                this._router.navigate('/#/drywallio/add-address');
            }
            
        }
        catch(e){
            alert('Server error.');
            console.log(e);
        }
        finally{
            this._loading.show(false);
        }
        
    }

    private async setSelectedTime(selectedTime: any) {
        this.selectedTime = selectedTime;
        
        this._view.highlightSelection(this.selectedTime);

        // this._view.setTextById('selected-time-label',
        //     this.formatTime(this.getCombinedDateTime())
        // );
    }

    private formatDate(date) {
        const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return date.toLocaleDateString('en-us', options);
    }

    private formatTime(date: Date) {
        return date.toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
        
        // const formattedTime = date.toLocaleTimeString([], {
        //     hour: 'numeric',
        //     minute: '2-digit',
        //     hour12: true // Use false for 24-hour format
        // });
    }

    getCombinedDateTime() {
        if (!this.selectedDate || !this.selectedTime)
            return null;

        const value = this.selectedDate.getTime() + this.selectedTime.getTotalMilliseconds();

        return new Date(value);
    }

    inject() {
    }

    private loadTimes(date: Date) {
        this.times = this.getAvailableTimes(date);
        this._view.setBookingTimes(this.times);

        this._view.addOnClickHandler('button[data-time]',
            async (fieldSelector, value, fieldName, element) => {
                await this.handleTimeButton(element)
            });
    }

    private async handleTimeButton(element) {
        const time = JSON.parse(element.getAttribute('data-time'));
        await this.setSelectedTime(TimeSpan.fromString(time.timeValue));
        await this.saveTimeSelection();
    }

    private getAvailableTimes(date) {
        // load from server in a later version
        return [
            {
                id: UuidHelper.newId(),
                time: '10:00 AM',
                timeValue: '10:00:00'
            },
            {
                id: UuidHelper.newId(),
                time: '12:00 PM',
                timeValue: '12:00:00'
            },
            {
                id: UuidHelper.newId(),
                time: '1:00 PM',
                timeValue: '13:00:00'
            },
            {
                id: UuidHelper.newId(),
                time: '2:00 PM',
                timeValue: '14:00:00'
            },
        ];
    }


} 

